import Actions from './Actions';
import ServiceAuth from '../../services/AuthService';
import ServiceAdmin from '../../services/AdminService';
import ServiceDp from "../../services/Services";
import jwt_decode from 'jwt-decode';

const authService = new ServiceAuth();
const adminService = new ServiceAdmin();
const dpService = new ServiceDp();

const userLogin = (username, password) => {
    return  (dispatch) => {

        dispatch({type: Actions.USER_LOGIN_REQUEST});

        authService.userLogin(username, password, (error, response) =>{
            if(error){
                if (error === "Username cannot be empty") {
                    dispatch({
                        type: Actions.USER_LOGIN_WARNING,
                        payload: error,
                        message: "Email cannot be empty"
                    });
                } else {
                    dispatch({
                        type: Actions.USER_LOGIN_FAIL,
                        payload: error,
                        message: error.message
                    });
                }
            }else{
                dispatch({
                    type: Actions.USER_LOGIN_SUCCESS,
                    acc_token: response.signInUserSession.accessToken.jwtToken,
                    id_token: response.signInUserSession.idToken.jwtToken,
                    message: "User Login Success."
                });
                dpService.getUploadFile({
                    folderName: "ProfileImage",
                    fileName: jwt_decode(response.signInUserSession.idToken.jwtToken).sub+'.jpg',
                    option: 1
                }, (err, res) =>{
                    dispatch({
                        type:Actions.USER_PRO_IMG_SUCCESS,
                        payload: res
                    });
                })
            }
        });
    };
};

const getLoginUserSession = () => {
    return  (dispatch) => {

        dispatch({type: Actions.USER_LOGIN_REQUEST});
    
        if("id_token" in localStorage)
        {
            dispatch({
                type: Actions.USER_SESSION_EX,
                id_token: localStorage.getItem('id_token'),
                acc_token: localStorage.getItem('acc_token')
            });
            authService.getUserLatestData((error,LatestData) => {
                if (!error){
                    dispatch({
                        type: Actions.USER_NEW_ATTR,
                        payload: LatestData.attributes
                    })
                }
            });
            dpService.getUploadFile({
                folderName: "ProfileImage",
                fileName: jwt_decode(localStorage.getItem('id_token')).sub+'.jpg',
                option: 1
            }, (err, res) =>{
                dispatch({
                    type:Actions.USER_PRO_IMG_SUCCESS,
                    payload: res
                });
            })
        }else{
            authService.getLoginUserSession((error,response) => {
                if(error){
                    dispatch({
                        type: Actions.USER_SESSION_NUL,
                        payload: "user Session null"
                    });
                }else{
                    dispatch({
                        type: Actions.USER_SESSION_EX,
                        id_token: response.idToken.jwtToken,
                        acc_token: response.accessToken.jwtToken
                    });
                    authService.getUserLatestData((error,LatestData) => {
                        if (!error){
                            dispatch({
                                type: Actions.USER_NEW_ATTR,
                                payload: LatestData.attributes
                            })
                        }
                    });
                    dpService.getUploadFile({
                        folderName: "ProfileImage",
                        fileName: jwt_decode(response.idToken.jwtToken).sub+'.jpg',
                        option: 1
                    }, (err, res) =>{
                        dispatch({
                            type:Actions.USER_PRO_IMG_SUCCESS,
                            payload: res
                        });
                    })
                }
            });
        } 
    }
};

const userLogOut = () => {
    return  (dispatch) => {

        dispatch({type: Actions.USER_LOGIN_REQUEST});

        authService.userLogOut((error, response) => {
            if(response){
                dispatch({
                    type: Actions.USER_LOGOUT
                });
                dispatch({
                    type: Actions.MERCHANT_DETAIL_RESET
                });
                getLoginUserSession();
            }
        });
    }
};

const userRegister = (userData) => {
    return  (dispatch) => {

        dispatch({type: Actions.USER_REGISTER_REQUEST});

        authService.userRegister(userData, (error, response) => {
            if(error){
                console.debug(error);
                dispatch({
                    type: Actions.USER_REGISTER_FAIL,
                    message: "Registration Fail."
                });
            }else{
                if(response.status){
                    dispatch({
                        type: Actions.USER_REGISTER_SUCCESS,
                        message: response.message,
                    });
                }else{
                    dispatch({
                        type: Actions.USER_REGISTER_FAIL,
                        message: response.message
                    });
                }
            }
        });
    }
};

const changePassword = (userData) => {
    return (dispatch) => {
        dispatch({type: Actions.USER_PASSWORD_CHG_REQUEST});

        authService.userChangePassword(userData.oldPassword, userData.newPassword, (err, res) => {
            if (err){
                console.debug(err);
                dispatch({
                    type: Actions.USER_PASSWORD_CHG_FAIL,
                    message: err.message
                });
            } else {
                console.debug(res);
                dispatch({type: Actions.USER_PASSWORD_CHG_SUCCESS,
                    message: 'Password Change Success.'
                });
            }
        })
    }
};

const userChangeAttribute = (userId, userData) => {
    return (dispatch) => {
        dispatch({type:Actions.USER_CHG_ATTR_REQUEST});

        adminService.userAttributeChange(userId, userData, (err, res) => {
            if(err){
                console.debug(err);
                dispatch({type:Actions.USER_CHG_ATTR_FAIL});
            }else {
                console.debug(res);
                if(res.status === 200){
                    dispatch({
                        type: Actions.USER_CHG_ATTR_SUCCESS,
                        payload: res.data.userAttributes
                    });
                    authService.getUserLatestData((error,LatestData) => {
                        if (!error){
                            dispatch({
                                type: Actions.USER_NEW_ATTR,
                                payload: LatestData.attributes
                            })
                        }
                    });
                }else {
                    dispatch({type:Actions.USER_CHG_ATTR_FAIL});
                }
            }
        })
    }
};

const getUserLatestData = () => {
    return (dispatch) => {
        authService.getUserLatestData((error,LatestData) => {
            if (!error){
                dispatch({
                    type: Actions.USER_NEW_ATTR,
                    payload: LatestData.attributes
                })
            }
        });
    }
};

export {getLoginUserSession, userLogin, userLogOut, userRegister, changePassword, userChangeAttribute, getUserLatestData};